import { executeApiCall } from 'services/api';
import { getLoaders } from 'entities/hooks/load';

import { Client, ClientBalanceEntry, ClientBalanceOverview, ClientBilling } from './types';
import { sortByName } from 'utils/array';

export const clientLoaders = getLoaders({
  list: {
    load: async (): Promise<Client[]> => {
      return executeApiCall({
        path: '/clients',
        method: 'get',
      });
    },

    defaultParser: sortByName,
  },

  billing: {
    load: async ({ id }: { id: string }): Promise<ClientBilling> => {
      return executeApiCall({
        path: `/clients/billing/${id}`,

        method: 'get',
      });
    },
  },

  balanceOverview: {
    load: async (): Promise<ClientBalanceOverview> => {
      return executeApiCall({
        path: `/clients/balance/overview`,

        method: 'get',
      });
    },
  },

  balanceEntries: {
    load: async ({ id, status }: { id: string; status: string }): Promise<ClientBalanceEntry[]> => {
      return executeApiCall({
        path: '/clients/balance',

        method: 'get',

        payload: {
          id,
          status,
        },
      });
    },
  },
});
